<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("integracao") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{$t("cadastros")}}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{$t("integracao")}}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!-- BOTÕES -->
                    <div class="header-buttons">
                        <button
                            class="delete-btn" 
                            type="button" 
                            @click="redirectToPage">
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>
                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <Geral
                    ref="tabGeral"
                    v-show="abas[abaSelecionada] == 'geral'"
                    @isChanged="isChanged = $event"
                />
                <Integracao
                    ref="tabIntegracao"
                    @isChangedAutenticacao="isChangedAutenticacao = $event"
                    @isChangedWhAutenticacao="isChangedWhAutenticacao = $event"
                    @isChangedWhGatilho="isChangedWhGatilho = $event"
                    v-if="abasAbertas['integracao'] && abas[abaSelecionada] == 'integracao'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

// Abas
import Geral from "@/components/integracao/abas/Geral";
import Integracao from "@/components/integracao/abas/Integracao";

export default {
    beforeRouteLeave(to, from, next) {
        if( this.isChangedAutenticacao || this.isChangedWhAutenticacao || this.isChangedWhGatilho){
            this.promptChangeTab(next);
        } else {
            next()
        }
    },
    components: {
        Geral,
        Integracao
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes("PACOTE"),
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                "geral",
                "integracao"
            ],
            gp: {},
            isImutavel: false,
            pacote:{ descricao: '' },
            abasAbertas: {},
            validation: null,
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            isSaving: false,
            cliente: null,
            idgrupo: null,
            isVenda: null,
            isChangedAutenticacao: false,
            isChangedWhAutenticacao: false,
            isChangedWhGatilho: false,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-pacote-kit');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'pacote-kit' },
        });

        this.isVenda = "vendas" === this.$route.meta.contexto ? true : false;

        if (this.$route.params.id && this.$route.params.name != 'ven-produto-grupo-new') {
            this.idgrupo = this.$route.params.id;
            this.isUpdate = true;
        }

    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        showMessageFromTab(data) {
            this.$root.showMessage(data.type, data.message);
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            
            tempTela = "integracao";
            
            const route = {
                    name: tempTela,
                    params: { id: this.$route.query['id'], name: this.$route.query.name },
                    query: { abaSelecionada: tempAba },
                    }
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-back-alteracoes-perdidas"),
                onConfirm: (_) => {
                    this.isChangedAutenticacao = false;
                    this.isChangedWhAutenticacao = false;
                    this.isChangedWhGatilho = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
    }
};
</script>
<style lang="scss" scoped>
    #main {
        padding: 0 20px;
        height: 100%;
    
        .page {
            position: relative;
            padding-left: 0;
    
            .nav-tabs-main {
                margin-bottom: 10px;
            }
            .nav-tabs-children {
                margin-bottom: 20px;
                li > a {
                    text-transform: capitalize;
                }
                li > ::after {
                    bottom: -4px;
                    border-width: 2px;
                }
            }
    
            .mobile-tab {
                cursor: pointer;
    
                &-list {
                    width: calc(100% + 40px);
                    margin-top: 20px;
                    margin-bottom: 20px;
                    margin-left: -20px;
                    padding-right: 20px;
                    padding-bottom: 5px;
                    padding-left: 20px;
                    border-bottom: 1px solid $table-border;
                    justify-content: center;
    
                    &::after {
                        content: "";
                        border: 3px solid $primary-color-click;
                        border-radius: 100px;
                        position: absolute;
                        width: calc(100% - 40px);
                        bottom: -3px;
                    }
    
                    &-item {
                        text-transform: uppercase;
                        font-weight: 600;
                        color: $text-color;
    
                        &.active {
                            color: $primary-color-click;
                        }
                    }
                }
    
                &-text {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $primary-color-click;
    
                    & ~ i {
                        color: $primary-color-click;
                    }
                }
            }
        }
    }
    
    @media only screen and (max-width: 760px) {
        .nav.nav-tabs-main {
            display: flex;
            justify-content: center;
            padding: 0;
            margin: 0;
    
            &::after {
                display: none;
            }
        }
    
        .nav.nav-tabs.nav-tabs-children {
            display: none;
        }
    }
    
    @media only screen and (min-width: 761px) {
        .mobile-tab-list {
            display: none;
        }
    }
    </style>
